import React, { type ReactNode } from 'react';

type Props = {
	children: ReactNode;
	externalId?: string;
	externalValues?: {
		[key: string]: unknown;
	};
};

function Link(props: Props) {
	const { children, ...rest } = props;

	// No need to add analytics props to the anchor tag
	delete rest.externalId;
	delete rest.externalValues;

	return <a {...rest}>{children}</a>;
}

export default Link;
